import {
  Card,
  SkeletonBodyText,
  SkeletonDisplayText,
  TextContainer
} from '@shopify/polaris';
import React from 'react';

class ListLoading extends React.Component {
  render() {
    return (
      <div className="no-shadow-card">
        <Card sectioned>
          <TextContainer>
            <SkeletonDisplayText size="small" />
            <SkeletonBodyText />
          </TextContainer>
        </Card>
      </div>
    );
  }
}

export default ListLoading;
